import styled from "styled-components"

import { WidthDelimiter, Flex } from "."

export default styled(Flex)`
  ${({ delimiter }) => WidthDelimiter(delimiter || "72.222222222vw")}
`
